module.exports = __webpack_public_path__ + "img/studentenwohnheimvallendar_3.36a10c81.jpg";